// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var DevicePixelRatio = require("../v5/common/DevicePixelRatio.bs.js");
var RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

var Types = {};

function unwrap_response_updateAgentProfilePersonalInfo(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["Agent"]);
}

var variablesConverter = {"updateAgentProfilePersonalInfoInput":{"website":{"b":""},"email":{"b":""}},"__root":{"input":{"r":"updateAgentProfilePersonalInfoInput"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

var wrapResponseConverter = {"__root":{"updateAgentProfilePersonalInfo_Agent":{"f":""},"updateAgentProfilePersonalInfo":{"u":"response_updateAgentProfilePersonalInfo"}}};

var wrapResponseConverterMap = {
  response_updateAgentProfilePersonalInfo: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

var responseConverter = {"__root":{"updateAgentProfilePersonalInfo_Agent":{"f":""},"updateAgentProfilePersonalInfo":{"u":"response_updateAgentProfilePersonalInfo"}}};

var responseConverterMap = {
  response_updateAgentProfilePersonalInfo: unwrap_response_updateAgentProfilePersonalInfo
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

var Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

var Utils = {};

var providedVariablesDefinition = {
  __relay_internal__pv__DevicePixelRatio: {
    providedVariable: DevicePixelRatio.get,
    get: DevicePixelRatio.get
  }
};

function makeNode(providedVariablesDefinition) {
  return ((function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ProfilePagePersonalInformationForm_UpdateAgentProfilePersonalInfoMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateAgentProfilePersonalInfo",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ProfilePagePersonalInformationForm_agent"
              }
            ],
            "type": "Agent",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__DevicePixelRatio"
      }
    ],
    "kind": "Operation",
    "name": "ProfilePagePersonalInformationForm_UpdateAgentProfilePersonalInfoMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateAgentProfilePersonalInfo",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "brokerage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phone",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "emailAddress",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "website",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "userEnteredDisplayName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProfilePhoto",
                "kind": "LinkedField",
                "name": "profilePhoto",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Variable",
                        "name": "ratio",
                        "variableName": "__relay_internal__pv__DevicePixelRatio"
                      },
                      {
                        "kind": "Literal",
                        "name": "width",
                        "value": 60
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "membershipStatus",
                "storageKey": null
              }
            ],
            "type": "Agent",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "type": "Node",
            "abstractKey": "__isNode"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3711cb542f0363610a2982a9a8f6749c",
    "id": null,
    "metadata": {},
    "name": "ProfilePagePersonalInformationForm_UpdateAgentProfilePersonalInfoMutation",
    "operationKind": "mutation",
    "text": "mutation ProfilePagePersonalInformationForm_UpdateAgentProfilePersonalInfoMutation(\n  $input: UpdateAgentProfilePersonalInfoInput!\n  $__relay_internal__pv__DevicePixelRatio: Float!\n) {\n  updateAgentProfilePersonalInfo(input: $input) {\n    __typename\n    ... on Agent {\n      ...ProfilePagePersonalInformationForm_agent\n    }\n    ... on Node {\n      __isNode: __typename\n      __typename\n      nodeId\n    }\n  }\n}\n\nfragment AgentInfo_agent on Agent {\n  id\n  displayName\n  brokerage\n  profilePhoto {\n    url(width: 60, ratio: $__relay_internal__pv__DevicePixelRatio)\n  }\n  membershipStatus\n}\n\nfragment ProfilePagePersonalInformationForm_agent on Agent {\n  firstName\n  lastName\n  brokerage\n  phone\n  emailAddress\n  website\n  userEnteredDisplayName\n  ...AgentInfo_agent\n}\n",
    "providedVariables": providedVariablesDefinition
  }
};
})());
}

var node = makeNode(providedVariablesDefinition);

var wrap_response_updateAgentProfilePersonalInfo = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_updateAgentProfilePersonalInfo = unwrap_response_updateAgentProfilePersonalInfo;
exports.wrap_response_updateAgentProfilePersonalInfo = wrap_response_updateAgentProfilePersonalInfo;
exports.Internal = Internal;
exports.Utils = Utils;
exports.providedVariablesDefinition = providedVariablesDefinition;
exports.node = node;
/* node Not a pure module */
